import { Box, Code, Heading } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { responseExamples } from "components/API/ApiRequestLanguages/responseExamples";

const ApiBlockResponseExample = () => {
  const pathname = useLocation().pathname;
  const [example, setExample] = useState();

  useEffect(() => {
    const endpointNameByPath = pathname.split("/").pop();
    setExample(responseExamples[endpointNameByPath]);
  }, [pathname]);

  return (
    <Box mt={10}>
      <Heading size="md">Response example</Heading>
      <Code mt={5} p={5}>
        {example && example}
      </Code>
    </Box>
  );
};

export default ApiBlockResponseExample;
